module.exports = __webpack_public_path__ + "img/bg_brush.0b5048d6.png";